var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdminLogoutDashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0961 3.79199C17.7601 3.38401 17.1362 3.33595 16.7521 3.69607C16.3442 4.03206 16.2961 4.65598 16.6562 5.04002L18.3122 6.96007H12.2402C11.7122 6.96007 11.2803 7.39198 11.2803 7.91998C11.2803 8.44798 11.7122 8.87989 12.2402 8.87989H18.3122L16.6562 10.7999C16.3202 11.2079 16.3442 11.8079 16.7521 12.1439C16.9442 12.312 17.1601 12.384 17.3761 12.384C17.6401 12.384 17.9041 12.2639 18.0961 12.048L21.1202 8.54389C21.4323 8.18395 21.4323 7.65593 21.1202 7.29584L18.0961 3.79199Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92006 15.84C11.136 15.84 14.0161 13.92 15.2401 10.92C15.4321 10.44 15.2161 9.86395 14.7121 9.67195C14.2321 9.47993 13.656 9.69589 13.464 10.2C12.552 12.456 10.3681 13.92 7.92002 13.92C4.60798 13.92 1.92002 11.232 1.92002 7.92C1.92002 4.60795 4.60798 1.92 7.92002 1.92C10.3681 1.92 12.552 3.384 13.464 5.64004C13.656 6.12 14.2321 6.36008 14.7121 6.16804C15.192 5.97602 15.4321 5.39995 15.2401 4.92C14.016 1.92 11.136 -3.8147e-06 7.92006 -3.8147e-06C3.55206 -3.8147e-06 6.10352e-05 3.55195 6.10352e-05 7.92C6.10352e-05 12.288 3.55202 15.84 7.92006 15.84Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLogoutDashIcon);
export default __webpack_public_path__ + "static/media/admin-logout-dash-icon.596e75b6cb45b1f5185525a5b24ccf4f.svg";
export { ForwardRef as ReactComponent };